export enum ReportDateIncrement {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    YEAR = 'YEAR',
    LIFETIME = 'LIFETIME',
}
